var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.976,
    height: 28.357,
    viewBox: "0 0 31.976 28.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-2.404 -5.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M32.69,19.064a1.187,1.187,0,0,1-.713-.238L18.439,8.672,4.9,18.826a1.188,1.188,0,1,1-1.425-1.9L17.726,6.238a1.186,1.186,0,0,1,1.425,0L33.4,16.926a1.188,1.188,0,0,1-.713,2.138Z",
    transform: "translate(0)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M28.565,32H21.439a1.188,1.188,0,0,1-1.188-1.188V22.5H15.5v8.313A1.188,1.188,0,0,1,14.313,32H7.188A1.188,1.188,0,0,1,6,30.814V14.188a1.188,1.188,0,1,1,2.375,0V29.627h4.75V21.313a1.188,1.188,0,0,1,1.188-1.188h7.126a1.188,1.188,0,0,1,1.188,1.188v8.313h4.75V14.188a1.188,1.188,0,1,1,2.375,0V30.814A1.188,1.188,0,0,1,28.565,32Z",
    transform: "translate(0.563 1.313)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8a2c7dc644f30a61ee1705203a0538f3.svg";
export { ForwardRef as ReactComponent };